module.exports = __webpack_public_path__ + "b3e083a60a72c9150651cbcaeb792af8.pdf";